/**
 * Parses the JSON text inside Vike's `<script id="vike_pageContext" type="application/json">`.
 * Returns `pageContext.data` (unknown shape) or `undefined`.
 */
export function parseVikePageContextDataField(jsonText: string): unknown {
  const trimmed = jsonText.trim();
  if (!trimmed) return undefined;
  try {
    const parsed = JSON.parse(jsonText) as { data?: unknown };
    return parsed.data;
  } catch {
    return undefined;
  }
}
